
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('radialGradient',{attrs:{"id":"14-a","cx":"50%","cy":"0%","r":"100%","fx":"50%","fy":"0%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#52A806"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#9CF34F"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#FFF","stroke":"#FFF","stroke-width":"3","d":"M32 6.5c6.183 0 12.996 2.354 18 6.475 4.477 3.687 7.5 8.765 7.5 14.79 0 5.258-3.433 11.353-7.933 16.648C43.2 51.903 34.898 57.5 32 57.5c-2.898 0-11.2-5.597-17.567-13.087-4.5-5.295-7.933-11.39-7.933-16.648 0-6.025 3.023-11.103 7.5-14.79C19.005 8.855 25.818 6.5 32 6.5z"}}),_c('path',{attrs:{"fill":"url(#14-a)","d":"M32 56c4.696 0 24-16.28 24-28.235C56 15.809 42.957 8 32 8S8 15.81 8 27.765C8 39.72 27.304 56 32 56z"}}),_c('path',{attrs:{"fill":"#353741","d":"M32 51c2.456 0 4.346-1.696 5.671-5.089a.333.333 0 00-.477-.41C35.463 46.501 33.731 47 32 47c-1.8 0-3.6-.54-5.4-1.62l-.078.13a.181.181 0 00-.263.22C27.587 49.243 29.501 51 32 51zM26.996 40.653c3.209-1.587 3.828-7.37 1.072-12.144-2.757-4.774-7.843-6.47-11.053-5.144-3.21 1.326-3.828 7.37-1.072 12.144s7.844 6.731 11.053 5.144zM36.004 40.653c-3.21-1.587-3.828-7.37-1.072-12.144 2.757-4.774 7.843-6.47 11.053-5.144 3.21 1.326 3.828 7.37 1.072 12.144s-7.844 6.731-11.053 5.144z"}}),_c('ellipse',{attrs:{"cx":"22","cy":"29","fill":"#B8BAC1","rx":"4","ry":"3","transform":"rotate(60 22 29)"}}),_c('ellipse',{attrs:{"cx":"42","cy":"29","fill":"#B8BAC1","rx":"4","ry":"3","transform":"scale(-1 1) rotate(60 0 -43.746)"}})])])
          )
        }
      }
    